// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/Apps/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_Apps{
  apps_apps(order_by: [{ name: asc }]) {
    id
    app_name: name
    properties: metadata(path: "properties")
    visibility: metadata(path: "visibility")
    name: metadata(path: "name")
    logo: metadata(path: "logo")
    description: metadata(path: "description")
    website: metadata(path: "website")
    connection: metadata(path: "connection")
    sync: metadata(path: "sync")
    automations: metadata(path: "automations")
    launchers: metadata(path: "launchers")
    features: metadata(path: "features")
    tags: metadata(path: "tags")
    connections(where: { status: { _neq: deleted } }) {
      id
      updated_at
      connected_at
      status
    }
    companies {
      id
      status
    }
  }
}

`